/* BRUUT - winkelwagen-lade. Werkt met de Shopify AJAX Cart API. */
(function () {
  var root = document.querySelector('[data-cd]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-cd-config') || '{}'); } catch (e) { cfg = {}; }

  var elCount = root.querySelector('[data-cd-count]');
  var elItems = root.querySelector('[data-cd-items]');
  var elEmpty = root.querySelector('[data-cd-empty]');
  var elBody = root.querySelector('[data-cd-body]');
  var elFoot = root.querySelector('[data-cd-foot]');
  var elTotal = root.querySelector('[data-cd-total]');
  var elSave = root.querySelector('[data-cd-save]');
  var elFill = root.querySelector('[data-cd-fill]');
  var elMsg = root.querySelector('[data-cd-msg]');
  var elUp = root.querySelector('[data-cd-up]');
  var elKnob = root.querySelector('[data-cd-knob]');
  var tiers = [].slice.call(root.querySelectorAll('[data-cd-tier]'));
  var dots = [].slice.call(root.querySelectorAll('[data-cd-dot]'));

  function money(cents) {
    var v = (cents || 0) / 100;
    var s = v.toFixed(2).replace('.', ',');
    var p = s.split(',');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + p.join(',');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  var busy = false;
  function setBusy(v) {
    busy = v;
    root.classList.toggle('is-busy', !!v);
  }

  function open() {
    root.hidden = false;
    // forceer een reflow zodat de transitie loopt
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var x = root.querySelector('.b-cd__x');
    if (x) x.focus();
  }

  function close() {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 280);
  }

  function progress(cart) {
    var t1 = cfg.tier1 || 0;
    var t2 = cfg.tier2 || 0;
    var total = cart.total_price || 0;
    var max = t2 > t1 ? t2 : t1;
    if (!max) return;

    var pct = Math.min(100, (total / max) * 100);
    if (total > 0 && pct < 4) pct = 4;
    root.style.setProperty('--b-p', pct + '%');
    if (elFill) elFill.style.width = pct + '%';

    tiers.forEach(function (el) {
      var at = parseInt(el.getAttribute('data-cd-tier'), 10) || 0;
      el.classList.toggle('is-done', total >= at);
    });
    dots.forEach(function (el) {
      var at = parseInt(el.getAttribute('data-cd-dot'), 10) || 0;
      el.classList.toggle('is-done', total >= at);
      el.style.left = max ? Math.min(100, (at / max) * 100) + '%' : '0';
    });
    if (elKnob) {
      elKnob.style.left = pct + '%';
      elKnob.classList.toggle('is-done', total >= max);
    }

    if (!elMsg) return;
    var done = false;
    var html = '';
    if (t1 && total < t1) {
      html = 'Nog <strong>' + money(t1 - total) + '</strong> voor ' + esc(cfg.label1 || 'gratis verzending');
    } else if (t2 && total < t2) {
      html = 'Nog <strong>' + money(t2 - total) + '</strong> voor ' + esc(cfg.label2 || 'een cadeau');
    } else if (t2) {
      done = true;
      html = 'Je hebt ' + esc(cfg.label1 || 'gratis verzending') + ' en ' + esc(cfg.label2 || 'je cadeau');
    } else {
      done = true;
      html = 'Je hebt ' + esc(cfg.label1 || 'gratis verzending');
    }
    elMsg.innerHTML = html;
    elMsg.classList.toggle('is-done', done);
  }

  function lineHtml(item) {
    var img = item.image ? '<img class="b-cd__thumb" src="' + esc(sized(item.image, 160)) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="b-cd__thumb"></span>';
    var variant = '';
    if (item.variant_title && item.variant_title !== 'Default Title') variant = esc(item.variant_title);
    var was = '';
    if (item.original_line_price > item.final_line_price) {
      was = '<s>' + money(item.original_line_price) + '</s>';
    }
    return '' +
      '<div class="b-cd__line" data-key="' + esc(item.key) + '">' +
        img +
        '<div>' +
          '<p class="b-cd__nm"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
          (variant ? '<p class="b-cd__var">' + variant + '</p>' : '') +
          '<div class="b-cd__qty">' +
            '<button type="button" data-cd-step="-1" aria-label="Eentje minder">' +
              (item.quantity > 1
                ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12h14"/></svg>'
                : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 7h14M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>') +
            '</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-cd-step="1" aria-label="Eentje meer">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M12 5v14M5 12h14"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="b-cd__pr">' + money(item.final_line_price) + was + '</div>' +
      '</div>';
  }

  function render(cart) {
    var n = cart.item_count || 0;
    if (elCount) elCount.textContent = '(' + n + ')';

    document.querySelectorAll('.b-cartcount').forEach(function (el) { el.textContent = n; });

    var empty = n === 0;
    if (elEmpty) elEmpty.hidden = !empty;
    if (elBody) elBody.hidden = empty;
    if (elFoot) elFoot.hidden = empty;

    if (elItems) elItems.innerHTML = (cart.items || []).map(lineHtml).join('');
    if (elTotal) elTotal.textContent = money(cart.total_price);

    if (elSave) {
      var saved = cart.total_discount || 0;
      elSave.hidden = saved <= 0;
      elSave.textContent = 'Je bespaart ' + money(saved);
    }

    progress(cart);

    // verberg cross-sells die al in de winkelwagen zitten
    if (elUp) {
      var ids = (cart.items || []).map(function (i) { return String(i.product_id); });
      var shown = 0;
      elUp.querySelectorAll('[data-cd-upitem]').forEach(function (el) {
        var hide = ids.indexOf(el.getAttribute('data-cd-upitem')) !== -1;
        el.hidden = hide;
        if (!hide) shown++;
      });
      elUp.hidden = shown === 0 || empty;
    }
  }

  function refresh(openAfter) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        if (openAfter) open();
        return cart;
      })
      .catch(function () {});
  }

  function post(url, body) {
    setBusy(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        setBusy(false);
        if (!res.ok) {
          alert(res.data && res.data.description ? res.data.description : 'Dit lukte niet. Probeer het opnieuw.');
          return null;
        }
        return res.data;
      })
      .catch(function () {
        setBusy(false);
        return null;
      });
  }

  // Toevoegen vanuit elk productformulier
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var fd = new FormData(form);
    var payload = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 }] };
    if (!payload.items[0].id) return;

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Bezig...'; }

    post('/cart/add.js', payload).then(function (d) {
      if (btn) { btn.disabled = false; if (label !== null) btn.innerHTML = label; }
      if (d) refresh(true);
    });
  });

  // Toevoegen vanuit een cross-sell
  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-cd-add]');
    if (add) {
      e.preventDefault();
      post('/cart/add.js', { items: [{ id: add.getAttribute('data-cd-add'), quantity: 1 }] }).then(function (d) {
        if (d) refresh(false);
      });
      return;
    }

    var step = e.target.closest('[data-cd-step]');
    if (step) {
      e.preventDefault();
      var line = step.closest('[data-key]');
      if (!line) return;
      var span = line.querySelector('.b-cd__qty span');
      var now = parseInt(span ? span.textContent : '1', 10) || 1;
      var next = now + (parseInt(step.getAttribute('data-cd-step'), 10) || 0);
      if (next < 0) next = 0;
      post('/cart/change.js', { id: line.getAttribute('data-key'), quantity: next }).then(function (cart) {
        if (cart) render(cart);
      });
      return;
    }

    if (e.target.closest('[data-cd-close]')) {
      e.preventDefault();
      close();
    }
  });

  // Winkelwagenlinks openen de lade
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    if (a.hasAttribute('data-cd-no')) return;
    var href = a.getAttribute('href') || '';
    if (/^\/(?:[a-z-]+\/)?cart\/?(?:[?#].*)?$/.test(href)) {
      e.preventDefault();
      refresh(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  window.bruutCart = { open: function () { refresh(true); }, close: close, refresh: refresh };

  refresh(false);
})();
